import $ from 'jquery';

export default class Responsive {
  constructor() {
    this.modifyDOM();
    this.addEvents();
  }

  modifyDOM() {
  }

  addEvents() {
    $('.toggle-box').on('click', '.plus-minus-toggle, .toggle-box__header', (e) => {
      let $target = $(e.target);

      if (!$target.hasClass('plus-minus-toggle')) {
        $target = $target.find('.plus-minus-toggle');
      }

      $target.toggleClass('collapsed');
      $target.closest('.toggle-box').toggleClass('active');

      return !$target.hasClass('plus-minus-toggle');
    });
  }
}
